import { apiUrl } from "../environmentConfig";
import { getDownloadUrl } from "./fileUrls";

export async function downloadFile(file) {
  const fileName = file?.file_name || "download";
  const url = file?.file_id
    ? `${apiUrl}/file/download/${file.file_id}`
    : getDownloadUrl(file);

  if (!url) {
    throw new Error("No download URL available");
  }

  const response = await fetch(url, { credentials: "include" });

  if (!response.ok) {
    throw new Error("Download failed");
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export function handleFileDownload(event, file) {
  event.preventDefault();
  event.stopPropagation();
  return downloadFile(file);
}
